<template>
  <section class="pt-50 mt-40">
    <div class="container" data-aos="fade-up" :data-aos-delay="200">
      <div class="row y-gap-30 justify-between items-center">
        <div class="col-xl-6 col-lg-6 col-md-10 order-2 order-lg-1">
          <div class="about-content">
            <h2 class="about-content__title">{{ $t('ready_to_transform') }}</h2>
            <p class="about-content__text">{{ $t('unlimited_access') }}</p>

            <div class="y-gap-20 pt-30">
              <div class="d-flex items-center x-gap-10">
                <div class="about-content-list__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <g clip-path="url(#clip0_653_20910)">
                      <path
                        d="M12 0C5.37262 0 0 5.37262 0 12C0 18.6278 5.37262 24 12 24C18.6278 24 24 18.6278 24 12C24 5.37262 18.6278 0 12 0ZM12 22.5236C6.21037 22.5236 1.5 17.7896 1.5 12C1.5 6.21033 6.21037 1.49995 12 1.49995C17.7896 1.49995 22.5 6.21035 22.5 12C22.5 17.7896 17.7896 22.5236 12 22.5236ZM16.7891 7.60913L9.74848 14.694L6.57785 11.5234C6.28498 11.2305 5.81023 11.2305 5.51698 11.5234C5.2241 11.8162 5.2241 12.291 5.51698 12.5839L9.2291 16.2964C9.52198 16.5889 9.99673 16.5889 10.29 16.2964C10.3237 16.2626 10.3526 16.2259 10.3789 16.1876L17.8504 8.66998C18.1429 8.3771 18.1429 7.90235 17.8504 7.60913C17.5571 7.31625 17.0824 7.31625 16.7891 7.60913Z"
                        fill="#09445D" />
                    </g>
                    <defs>
                      <clipPath id="clip0_653_20910">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div class="about-content-list__title">{{ $t('aboutContent.affordablePlans') }}</div>
              </div>

              <div class="d-flex items-center x-gap-10">
                <div class="about-content-list__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <g clip-path="url(#clip0_653_20910)">
                      <path
                        d="M12 0C5.37262 0 0 5.37262 0 12C0 18.6278 5.37262 24 12 24C18.6278 24 24 18.6278 24 12C24 5.37262 18.6278 0 12 0ZM12 22.5236C6.21037 22.5236 1.5 17.7896 1.5 12C1.5 6.21033 6.21037 1.49995 12 1.49995C17.7896 1.49995 22.5 6.21035 22.5 12C22.5 17.7896 17.7896 22.5236 12 22.5236ZM16.7891 7.60913L9.74848 14.694L6.57785 11.5234C6.28498 11.2305 5.81023 11.2305 5.51698 11.5234C5.2241 11.8162 5.2241 12.291 5.51698 12.5839L9.2291 16.2964C9.52198 16.5889 9.99673 16.5889 10.29 16.2964C10.3237 16.2626 10.3526 16.2259 10.3789 16.1876L17.8504 8.66998C18.1429 8.3771 18.1429 7.90235 17.8504 7.60913C17.5571 7.31625 17.0824 7.31625 16.7891 7.60913Z"
                        fill="#09445D" />
                    </g>
                    <defs>
                      <clipPath id="clip0_653_20910">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div class="about-content-list__title">{{ $t('aboutContent.learnAtYourOwnPace') }}</div>
              </div>

              <div class="d-flex items-center x-gap-10">
                <div class="about-content-list__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <g clip-path="url(#clip0_653_20910)">
                      <path
                        d="M12 0C5.37262 0 0 5.37262 0 12C0 18.6278 5.37262 24 12 24C18.6278 24 24 18.6278 24 12C24 5.37262 18.6278 0 12 0ZM12 22.5236C6.21037 22.5236 1.5 17.7896 1.5 12C1.5 6.21033 6.21037 1.49995 12 1.49995C17.7896 1.49995 22.5 6.21035 22.5 12C22.5 17.7896 17.7896 22.5236 12 22.5236ZM16.7891 7.60913L9.74848 14.694L6.57785 11.5234C6.28498 11.2305 5.81023 11.2305 5.51698 11.5234C5.2241 11.8162 5.2241 12.291 5.51698 12.5839L9.2291 16.2964C9.52198 16.5889 9.99673 16.5889 10.29 16.2964C10.3237 16.2626 10.3526 16.2259 10.3789 16.1876L17.8504 8.66998C18.1429 8.3771 18.1429 7.90235 17.8504 7.60913C17.5571 7.31625 17.0824 7.31625 16.7891 7.60913Z"
                        fill="#09445D" />
                    </g>
                    <defs>
                      <clipPath id="clip0_653_20910">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div class="about-content-list__title">{{ $t('aboutContent.coursesFromIndustryLeaders') }}</div>
              </div>

              <div class="d-flex items-center x-gap-10">
                <div class="about-content-list__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <g clip-path="url(#clip0_653_20910)">
                      <path
                        d="M12 0C5.37262 0 0 5.37262 0 12C0 18.6278 5.37262 24 12 24C18.6278 24 24 18.6278 24 12C24 5.37262 18.6278 0 12 0ZM12 22.5236C6.21037 22.5236 1.5 17.7896 1.5 12C1.5 6.21033 6.21037 1.49995 12 1.49995C17.7896 1.49995 22.5 6.21035 22.5 12C22.5 17.7896 17.7896 22.5236 12 22.5236ZM16.7891 7.60913L9.74848 14.694L6.57785 11.5234C6.28498 11.2305 5.81023 11.2305 5.51698 11.5234C5.2241 11.8162 5.2241 12.291 5.51698 12.5839L9.2291 16.2964C9.52198 16.5889 9.99673 16.5889 10.29 16.2964C10.3237 16.2626 10.3526 16.2259 10.3789 16.1876L17.8504 8.66998C18.1429 8.3771 18.1429 7.90235 17.8504 7.60913C17.5571 7.31625 17.0824 7.31625 16.7891 7.60913Z"
                        fill="#09445D" />
                    </g>
                    <defs>
                      <clipPath id="clip0_653_20910">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div class="about-content-list__title">{{ $t('aboutContent.earnCertificates') }}</div>
              </div>
            </div>
            <!----Subscribe section------------------>
            <div class="d-flex align-items-center mt-30 flex-wrap" style="gap: 10px">
              <input type="email" :placeholder="$t('aboutContent.placeholderEmail')" class="subscribe-input" v-model="userEmail"/>
              <button @click="RedirectToSignUp"
                class="button main-button text-white d-flex justify-center items-center subscribe px-15">
                {{ $t('aboutContent.subscribeNow') }}
                <div class="rotate-svg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M15.586 10.6569L11.636 6.70692C11.4538 6.51832 11.353 6.26571 11.3553 6.00352C11.3576 5.74132 11.4628 5.49051 11.6482 5.3051C11.8336 5.11969 12.0844 5.01452 12.3466 5.01224C12.6088 5.00997 12.8614 5.11076 13.05 5.29292L18.707 10.9499C18.8002 11.0426 18.8741 11.1527 18.9246 11.2741C18.9751 11.3954 19.001 11.5255 19.001 11.6569C19.001 11.7883 18.9751 11.9184 18.9246 12.0398C18.8741 12.1611 18.8002 12.2713 18.707 12.3639L13.05 18.0209C12.9578 18.1164 12.8474 18.1926 12.7254 18.245C12.6034 18.2974 12.4722 18.325 12.3394 18.3262C12.2066 18.3273 12.0749 18.302 11.952 18.2517C11.8291 18.2015 11.7175 18.1272 11.6236 18.0333C11.5297 17.9394 11.4555 17.8278 11.4052 17.7049C11.3549 17.582 11.3296 17.4503 11.3307 17.3175C11.3319 17.1847 11.3595 17.0535 11.4119 16.9315C11.4643 16.8095 11.5405 16.6992 11.636 16.6069L15.586 12.6569H6C5.73478 12.6569 5.48043 12.5516 5.29289 12.364C5.10536 12.1765 5 11.9221 5 11.6569C5 11.3917 5.10536 11.1373 5.29289 10.9498C5.48043 10.7623 5.73478 10.6569 6 10.6569H15.586Z"
                      fill="white" />
                  </svg>
                </div>
              </button>
            </div>

            <span class="errorMessage text-danger" v-if="v$.userEmail.$error&&!errorMessage">
                {{ v$.userEmail.$errors[0].$message }}
            </span>

            <span class="errorMessage text-danger" v-if="errorMessage">
               {{ $t('errorMessages.alreadyRegistered') }}
            </span>

          </div>
        </div>

        <div class="col-xl-5 col-lg-6 order-1 order-lg-2">
          <div data-aos="fade-up" :data-aos-delay="200" class="about-image">
            <img src="../../assets/images/home/home-last-img.png" alt="image" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import useVuelidate from '@vuelidate/core'
import { required, email, helpers } from '@vuelidate/validators'
import AOS from "aos";
export default {
  data() {
    return {
      userEmail: '',
      errorMessage : false
    }
  },
  setup() {
    return { v$: useVuelidate() }
  },
  validations() {
    return {
      userEmail: { email: helpers.withMessage(() => this.$t('validations.email'), email),
      required: helpers.withMessage(() => this.$t('validations.required'), required) },
    }
  },
  methods: {
    RedirectToSignUp() {
      this.v$.$validate();
      if(!this.$store.getters.isAuthenticated){
        if (!this.v$.$error) {
          console.log(this.userEmail);
          this.$store.commit('setUserEmail',this.userEmail)
          this.$router.push('/signup');
        }
      }else{
        this.errorMessage = true;
      }
    }
  },
  mounted() {
    AOS.init({
      duration: 1000, // Animation duration
      once: true, // Whether animation should happen only once
    });
  },
};
</script>
